var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyBookz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 3.481211)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,5.74060544 C0.723857625,5.74060544 0.5,5.96446307 0.5,6.24060544 L0.5,22.2406054 C0.5,22.5167478 0.723857625,22.7406054 1,22.7406054 L6,22.7406054 C6.27614237,22.7406054 6.5,22.5167478 6.5,22.2406054 L6.5,6.24060544 C6.5,5.96446307 6.27614237,5.74060544 6,5.74060544 L1,5.74060544 Z M1.9,9.24060544 L5.066667,9.24060544 L5.066667,20.7406054 L1.9,20.7406054 L1.9,9.24060544 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5571759,0.879039052 L20.5571759,0.879039052 C21.1094606,0.879039052 21.5571759,1.3267543 21.5571759,1.87903905 L21.5571759,21.8790391 C21.5571759,22.4313238 21.1094606,22.8790391 20.5571759,22.8790391 L15.5571759,22.8790391 C15.0048911,22.8790391 14.5571759,22.4313238 14.5571759,21.8790391 L14.5571759,1.87903905 C14.5571759,1.3267543 15.0048911,0.879039052 15.5571759,0.879039052 Z M15.3851759,8.74570572 L20.8251759,8.74570572 L20.8251759,7.14570572 L15.3851759,7.14570572 L15.3851759,8.74570572 Z M15.3851759,5.74570572 L20.8251759,5.74570572 L20.8251759,4.14570572 L15.3851759,4.14570572 L15.3851759,5.74570572 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    transform: "translate(18.057176, 11.879039) rotate(-14.000000) translate(-18.057176, -11.879039) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,7.74060544 C8.22385763,7.74060544 8,7.96446307 8,8.24060544 L8,22.2406054 C8,22.5167478 8.22385763,22.7406054 8.5,22.7406054 L12.5,22.7406054 C12.7761424,22.7406054 13,22.5167478 13,22.2406054 L13,8.24060544 C13,7.96446307 12.7761424,7.74060544 12.5,7.74060544 L8.5,7.74060544 Z M9.2,10.7406054 L11.8,10.7406054 L11.8,19.7406054 L9.2,19.7406054 L9.2,10.7406054 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.500000, 8.955071)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Path-2",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBookz);
export default __webpack_public_path__ + "static/media/myBookz.2038eb69a9c50a8f5951d17719de46c6.svg";
export { ForwardRef as ReactComponent };